import React, { useState, useEffect } from "react";
import ClosedEventsDashboard from "./ClosedEventsDashboard";
import { AuthorizationProvider } from "meportal/AuthorizationProvider"
import { useEventType } from "../../providers/EventTypeProvider";
import { AtaCodeProvider } from "../../providers/AtaCodeProvider";
import { AircraftListProvider } from "../../providers/AircraftListProvider";
import { FleetTypeProvider } from "../../providers/FleetTypeProvider";

function ClosedDashboard() { 
const {eventTypes} = useEventType();
const [eventTypeIds, setEventTypeIds] = useState<string[]>([]);

useEffect(() => {
    const activeEventTypes = () => {
      let activeTypes = eventTypes.filter((eventType) => eventType.IsActive);
      let ids = activeTypes.map((eventType) => eventType.Airline + ":" + eventType.Name);
      setEventTypeIds(ids);
    }
    activeEventTypes();
  }, [eventTypes]);

return (
    <AuthorizationProvider eventId={eventTypeIds}>
      <AircraftListProvider>
        <AtaCodeProvider>
          <FleetTypeProvider>
            <ClosedEventsDashboard />
          </FleetTypeProvider>
        </AtaCodeProvider>
      </AircraftListProvider>
    </AuthorizationProvider>
);

}

export default ClosedDashboard;